//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const UnhandledExceptionFromSwitch: FeatureFlag = {"Id":"UnhandledExceptionFromSwitch","Label":"(QA) FAIL ALL SWITCHES WITH A UNHANDLED EXCEPTION","Impact":"For QA. Throws an exception. For testing failure","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":1};
